import { Box, Card, Container, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { News } from '../config/types';
import { Link } from 'react-router-dom';


export const host = process.env.REACT_APP_TVAPP_SERVER_HOST;

const Home = () => {
    const [list1, setList1] = useState<News[]>([])
    const [list2, setList2] = useState<News[]>([])
    const [list3, setList3] = useState<News[]>([])

    const getNewsList = async () => {
        const url = host + '/data/api.tvAppOpenApi/getNewsList?mark=%E6%9C%80%E6%96%B0%E6%B6%88%E6%81%AF';


        const data = {};

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const responseData = await response.json();


            if (responseData.code === 1) {
                fillNewsList(responseData.data.list);
            }

            console.log(responseData);
        } catch (error) {
            console.error(error);
        }
    }

    const fillNewsList = (lists: News[]) => {
        const list1 = [];
        const list2 = [];
        const list3 = [];
        for (let i = 0; i < lists.length; i++) {
            const item = lists[i];
            if (i % 5 === 0) {
                list1.push(item);
            }
            if (i % 5 === 1 || i % 5 === 2) {
                list2.push(item);
            }

            if (i % 5 === 3 || i % 5 === 4) {
                list3.push(item);
            }
        }

        setList1(list1);
        setList2(list2);
        setList3(list3);
    }


    useEffect(() => {
        getNewsList();
    }, [])

    return <Layout>
        {/* page content */}
        <section className="w3l-banner py-5" id="banner">
            <div className="midd-w3 py-lg-5 py-md-4">
                <div className="container py-lg-2">
                    <div className="row">
                        <div className="col-lg-6 banner-content align-self pr-lg-5">
                            <h3 className="">美术<br></br>不止是美术</h3>
                            <p className="mt-3">美术不止步于美术，它还包含了自我情感的表达<br></br>家庭教育的补充，文化知识的摄入，认识世界的方式</p>
                            <Link to='/contact' className="btn btn-style btn-outline-dark mt-lg-5 mt-4">联系我们 <span
                                className="fa fa-arrow-right  ml-3" /></Link>
                        </div>
                        <div className="col-lg-6 text-center mt-lg-0 mt-md-5 mt-4">
                            <div className="image-block position-relative">
                                <img src="bloommeta/banner.jpg" alt="" className="img-fluid mt-lg-0 mt-4" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <section className="w3l-content-4 py-5" id="ppgs">
            <div className="content-4-main py-lg-5 py-md-4">
                <div className="container">
                    <div className="ab-info-in row">
                        <div className="ab-min-left col-lg-5">
                            <div className="title-content text-left">
                                <h3 className="title-subhny">品牌故事</h3>
                                <h3 className="pr-lg-5">“我们将一如既往的
                                    用专业、用态度，给孩子们提供高质量的儿童美学课，
                                    用情怀、用爱心，和每一个小朋友携手探索艺术之美。”
                                </h3>
                            </div>
                        </div>
                        <div className="ab-min-right col-lg-7 pl-lg-5">
                            <p className="my-3"> 2022年我们带着全新的品牌“花儿和马嗒”，用沉浸式教学体验<br></br><br></br>
                                致力于美育与通识教育相结合的方式，为孩子的成长提供更多的可能性<br></br><br></br>
                                教研团队历时叁年打造，迭代研发美育课程<br></br><br></br>
                                学员考级成绩优异，被评为美术考级考点<br></br><br></br>
                                团队创立于2016年，至今已深耕美育行业数年<br></br><br></br>
                                累计陪伴2000+孩子以美育作为方法成长<br></br><br></br>
                                主城6+6校区逐步上线（江北、渝北、两江新区、南坪、大学城、微电园）
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div className="w3l-agent-block py-5" id="jytd">
            <div className="container py-lg-4">
                <div className="row align-items-center mt-lg-5">
                    <div className="col-lg-6">
                        <div className="agent-block-image px-lg-5">
                            <img src="bloommeta/team_work.png" className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="col-lg-6 mt-lg-0 mt-5 pl-lg-5">
                        <h6 className="title-subhny">Leadership</h6>
                        <h3 className="title-w3l">教研团队</h3>
                        <p className="my-3">

                            <ul>
                                <li>四川美术学院</li>
                                <li>南京艺术学院</li>
                                <li>伦敦艺术学院</li>
                                <li>SVA美国纽约视觉学院</li>
                            </ul>
                        </p>
                        <p className=""> 教育背景的研发团队
                            研发迭代</p>
                        <a href="#" className="btn btn-style btn-primary mt-md-5 mt-4">查看更多 <span className="fa fa-arrow-right ml-3"></span></a>
                    </div>
                </div>
            </div>
        </div>


        <section className="w3l-bottom-grids-6 py-5" id="why">
            <div className="container py-lg-5 py-md-4 py-2">
                <div className="title-content text-center">
                    <h6 className="title-subhny text-center">与孩子一起成长</h6>
                    <h3 className="title-w3l mb-sm-5 mb-4 pb-sm-o pb-2 text-center">为什么学美术</h3>
                </div>
                <div className="grids-area-hny main-cont-wthree-fea row">

                    <div className="col-lg-4 col-md-6 grids-feature">
                        <div className="area-box icon-blue">
                            <span className="fa">01</span>
                            <h4><a href="/" className="title-head">孩子喜欢</a></h4>
                            <p>孩子进入绘画敏感期<br></br>绘画先于文字</p>

                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 grids-feature">
                        <div className="area-box icon-pink">
                            <span className="fa">02</span>
                            <h4><a href="/" className="title-head">培养审美</a></h4>
                            <p>美好的事物具有先天的吸引力<br></br>目光所及皆是美术</p>

                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 grids-feature">
                        <div className="area-box icon-yellow">
                            <span className="fa">03</span>
                            <h4><a href="/" className="title-head">未来时代的核心竞争力</a></h4>
                            <p>未来智能化时代想象力.创造力和身边的人产生共情和爱的能力是无法被取代的</p>

                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 grids-feature">
                        <div className="area-box icon-orange">
                            <span className="fa">04</span>
                            <h4><a href="/" className="title-head">为了升学</a></h4>
                            <p>小升初特长   美术中考<br></br>国家教育政策在不断的改革</p>

                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 grids-feature">
                        <div className="area-box icon-red">
                            <span className="fa">05</span>
                            <h4><a href="/" className="title-head">丰富认知维度</a></h4>
                            <p>观察世界方式的转变</p>

                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 grids-feature">
                        <div className="area-box icon-green">
                            <span className="fa">06</span>
                            <h4><a href="/" className="title-head">孩子的情感表达</a></h4>
                            <p>孩子没有完整的语言，没有熟练的文字，美术也是一门语言，绘画的目的为了表达，绘画的过程是孩子早期的精神活动</p>

                        </div>
                    </div>
                </div>
            </div>
        </section>



        <div className="w3l-agent-block py-5" id="jyll">
            <div className="container py-lg-4">
                <div className="row align-items-center mt-5">
                    <div className="col-lg-6">
                        <div className="agent-block-image px-lg-5">
                            <img src="bloommeta/box_1.png" className="img-fluid" alt="" />
                            <img src="bloommeta/box_2.png" className="img-fluid" alt="" />
                        </div>
                    </div>
                    <div className="col-lg-6 mt-lg-0 mt-5 pl-lg-5">
                        <h6 className="title-subhny">课程</h6>
                        <h3 className="title-w3l">教育理念</h3>
                        <p className="my-3">
                            注重儿童思维成长与心理成长，包含思维<br></br>
                            知识能力、情感与价值观层面的整体培养<br></br><br></br>

                            把美育作为工具，结合儿童基础通识教育常识认知<br></br>
                            人文与科技等主题，打破传统儿童科陈式教育的壁垒<br></br><br></br>
                            结合结构化谱系式艺术创意教学<br></br>

                            这是我们的美育理念<br></br><br></br>

                            课程从STEAM教学模式出发，涵盖科学、技术、工程、艺术、数学等5大领域的知识。根据孩子认知生理发展阶段，匹配相应学习内容。旨在打破学科疆域，用艺术融合其他领域，提升孩子综合素养
                        </p>

                        <div className="subscribe-cat">
                            <div className="subscribe-cat-gd">
                                <a href="#" className="subscribe-cat-link">科学</a>
                                <p className="mt-2">  植物学  天文学
                                    地理学    物理学等</p>
                            </div>
                            <div className="subscribe-cat-gd">
                                <a href="#" className="subscribe-cat-link">技术</a>
                                <p className="mt-2">声音处理技术
                                    摄影技术
                                    虚拟抠像技术等</p>
                            </div>
                            <div className="subscribe-cat-gd">
                                <a href="#" className="subscribe-cat-link">工程</a>
                                <p className="mt-2">电脑软件
                                    场景模型建构等
                                </p>
                            </div>
                            <div className="subscribe-cat-gd">
                                <a href="#" className="subscribe-cat-link">数学</a>
                                <p className="mt-2">尺度测量
                                    黄金比例分割等
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <section className="w3l-content-4 py-5" id="wmdys">
            <div className="content-4-main py-lg-5 py-md-4">
                <div className="container">
                    <div className="title-content text-center">
                        <h3 className="title-subhny"> Why choose us</h3>
                        <h3 className="title-w3l">花儿和马嗒5大优势</h3>
                        <p><br></br>小班授课&nbsp;&nbsp;&nbsp;&nbsp;开放课堂&nbsp;&nbsp;&nbsp;&nbsp;专注美育&nbsp;&nbsp;&nbsp;&nbsp;专业教研&nbsp;&nbsp;&nbsp;&nbsp;优质教学</p>
                    </div>
                    <div className="content-info-in row pt-lg-5">
                        <div className="content-left col-lg-4 mt-lg-0 mt-md-5 mt-3">
                            <div className="content-4-main-gd">
                                <div className="row content4-right-grids">
                                    <div className="col-sm-3 content4-right-icon">
                                        <div className="content4-icon icon-clr1">
                                            <span className="fa fa-renren"></span>
                                        </div>
                                    </div>
                                    <div className="col-sm-9 content4-right-info pl-4">
                                        <h6><a href="#url">必修课程</a></h6>
                                        <p>创作plus  户外写生课</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-left col-lg-4 mt-lg-0 mt-md-5 mt-3">
                            <div className="content-4-main-gd">
                                <div className="row content4-right-grids">
                                    <div className="col-sm-3 content4-right-icon">
                                        <div className="content4-icon icon-clr2">
                                            <span className="fa fa-renren"></span>
                                        </div>
                                    </div>
                                    <div className="col-sm-9 content4-right-info pl-4">
                                        <h6><a href="#url">选修课程</a></h6>
                                        <p>亲子艺术课  博物馆游学课</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-left col-lg-4 mt-lg-0 mt-md-5 mt-3">
                            <div className="content-4-main-gd">
                                <div className="row content4-right-grids">
                                    <div className="col-sm-3 content4-right-icon">
                                        <div className="content4-icon icon-clr3">
                                            <span className="fa fa-renren"></span>
                                        </div>
                                    </div>
                                    <div className="col-sm-9 content4-right-info pl-4">
                                        <h6><a href="#url">假期课程</a></h6>
                                        <p>寒暑假特色课  考级集训课  国际游学课</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>



        <section className="w3l-agent-block py-5" id="news">
            <div className="container py-lg-5 py-md-5 py-2">
                <div className="row">
                    <div className="col-lg-4 news-left">
                        <h6 className="title-subhny">Explore</h6>
                        <h3 className="title-w3l">
                            最新消息</h3>
                        <p className="my-3"> 脚踏实地、认认真真上好每一节课
                            这是每一个花儿和马嗒教师
                            基本的价值观
                        </p>
                        <>
                            {list1 && list1.length > 0 ? (
                                list1.map((v, index) =>
                                    <div className="w3l-news-gd mt-5">
                                        <Link to={'/news/detail?id=' + v.id}><img src={v.cover} alt="" className="radius-image img-fluid" /></Link>
                                        <div className="w3l-news-gd-inf mt-4">
                                            <h6 className="date">{v.create_at}</h6>
                                            <h4>
                                                <Link to={'/news/detail?id=' + v.id} className="news-link">{v.name}</Link>
                                            </h4>
                                        </div>
                                    </div>
                                )
                            ) : (null)}
                        </>



                    </div>
                    <div className="col-lg-8 news-left mt-lg-0 mt-5 pl-lg-5">
                        <div className="row ">
                            <div className="col-md-6 news-gd-1 mt-lg-5 pt-lg-5 px-lg-4">
                                <>
                                    {list2 && list2.length > 0 ? (
                                        list2.map((v, index) =>
                                            <div className="w3l-news-gd mb-5">
                                                <Link to={'/news/detail?id=' + v.id}><img src={v.cover} alt="" className="radius-image img-fluid" /></Link>
                                                <div className="w3l-news-gd-inf mt-4">
                                                    <h6 className="date">{v.create_at}</h6>
                                                    <h4>
                                                        <Link to={'/news/detail?id=' + v.id} className="news-link">{v.name}</Link>
                                                    </h4>
                                                </div>
                                            </div>
                                        )
                                    ) : (null)}
                                </>


                            </div>
                            <div className="col-md-6 news-gd-1 px-lg-4">
                                <>
                                    {list3 && list3.length > 0 ? (
                                        list3.map((v, index) =>

                                            <div className="w3l-news-gd mb-5">
                                                <Link to={'/news/detail?id=' + v.id}><img src={v.cover} alt="" className="radius-image img-fluid" /></Link>
                                                <div className="w3l-news-gd-inf mt-4">
                                                    <h6 className="date">{v.create_at}</h6>
                                                    <h4>
                                                        <Link to={'/news/detail?id=' + v.id} className="news-link">{v.name}</Link>
                                                    </h4>
                                                </div>
                                            </div>
                                        )
                                    ) : (null)}
                                </>


                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </section>
        {/* page content end*/}
    </Layout>
}
export default Home;